import { useState, useCallback } from "react";
import { showErrorMessage, showSuccessMessage } from "../../components/shared/pagination/messages";
import {
  fetchAllActiveUsers,
  fetchAllInactiveUsers,
  deleteUsers,
  fetchAllUsers
} from "../../service/UserService";

export const useUsers = () => {
  const [userList, setUserList] = useState([]);
  const [activeTotalElements, setActiveTotalElements] = useState(0);

  const fetchUsers = useCallback(async ({ isActive, currentPage, pageSize, searchText, selectedRole }) => {
    try {
      const response = await fetchAllUsers(currentPage - 1, pageSize, searchText, isActive,selectedRole );

      if (response?.status === "SUCCESS") {
        const list = response.data?.content || [];
        const total = response.data?.totalElements || 0;
        setUserList(list);
        setActiveTotalElements(total);

        return response;
      }
    } catch (error) {
      showErrorMessage("Failed to load users");
    }
  }, []);

  const removeUser = useCallback(async (userId) => {
    try {
      const response = await deleteUsers(userId);
      showSuccessMessage("User deleted successfully!");
      return response?.data;
    } catch (error) {
      showErrorMessage(error?.message || "Error occurred while deleting the User.");
    }
  }, []);

  return {
    userList,
    activeTotalElements,
    fetchUsers,
    removeUser,
  };
};